const Monetario = ({ valor }) => {
  const valorStr = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor)
  return valorStr
}
export default Monetario
